import * as React from "react";
const SvgSpaceForce = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("circle", {
	cx: 16,
	cy: 16,
	r: 16,
	fill: "url(#paint0_linear_14624_16592)"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 4.85815,
	y: 8.07031,
	width: 4.72543,
	height: 8.86177,
	transform: "rotate(-44.6872 4.85815 8.07031)",
	fill: "white"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 17.6154,
	y: 20.7344,
	width: 4.72543,
	height: 8.86177,
	transform: "rotate(-44.6872 17.6154 20.7344)",
	fill: "white"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 10.9415,
	y: 15.9766,
	width: 8.76315,
	height: 6.70365,
	transform: "rotate(-44.6872 10.9415 15.9766)",
	fill: "#C4C4C4"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 10.962,
	y: 15.9766,
	width: 8.76315,
	height: 6.70365,
	transform: "rotate(-44.6872 10.962 15.9766)",
	fill: "white"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 7.58252,
	y: 23.3672,
	width: 5.14644,
	height: .764869,
	transform: "rotate(-44.6872 7.58252 23.3672)",
	fill: "white"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 11.9125,
	y: 13.4688,
	width: 2.3212,
	height: 11.2169,
	transform: "rotate(-44.6872 11.9125 13.4688)",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7.91321 16.0575C8.07175 15.8993 8.31496 15.7972 8.669 15.7877C9.02607 15.7781 9.46986 15.8645 9.97653 16.0587C10.9891 16.4467 12.1777 17.2352 13.2834 18.3436C14.389 19.452 15.1739 20.642 15.5594 21.6555C15.7523 22.1628 15.8382 22.6073 15.8278 22.9644C15.8173 23.3182 15.7146 23.5614 15.5561 23.7195C15.3977 23.8776 15.1541 23.9797 14.8003 23.9893C14.4432 23.9989 13.9989 23.9118 13.4921 23.7176C12.4796 23.3297 11.2916 22.5417 10.1859 21.4333C9.08025 20.3249 8.29472 19.1343 7.90925 18.1208C7.71642 17.6136 7.63109 17.1696 7.64158 16.8126C7.652 16.4586 7.75469 16.2156 7.91321 16.0575Z",
	stroke: "white",
	strokeWidth: .844885
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 7.31834,
	cy: 24.2258,
	r: .89769,
	fill: "white"
}), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint0_linear_14624_16592",
	x1: 27.0891,
	y1: 3.64357,
	x2: 7.33993,
	y2: 20.33,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", { stopColor: "#FE4AC9" }), /* @__PURE__ */ React.createElement("stop", {
	offset: 1,
	stopColor: "#F98E0A"
}))));
export default SvgSpaceForce;
